import { connect } from 'react-redux';
import ThemMoiKho from 'components/CommonComponent/ThemMoiKho';
import { postDataStore } from 'actions/AddOrEditStore';

const mapStateToProps = (state) => ({
  addoreditstore: state.addoreditstore,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  postDataStore: (dataPost, dataSearch) =>
    dispatch(postDataStore(dataPost, dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ThemMoiKho);
